import angular from 'angular';
import onboardingTracker from './onboardingTracker';
import './style.scss';

export default angular
  .module('components.onboardingTracker', [])
  .component('onboardingTracker', onboardingTracker).name;
